import { useContext } from 'react'
import { NavigationContext } from '../contexts/navigationContextValue'
import type { NavigationContextValue } from '../contexts/navigationContextValue'
import type { NavOpts } from '../routes'

export function useAppNavigate(): (target: string, opts?: NavOpts) => void {
  const ctx = useContext(NavigationContext)!
  return ctx.navigate
}

export function useNavigation(): NavigationContextValue {
  return useContext(NavigationContext)!
}
